(function(){
  if(window.STHCartAssistant)return;
  var state={lastShown:0,loadTimer:null,lastKey:null,lastQty:1,lastTitle:"",lastAddButton:null,reminded:false};
  var style=document.createElement("style");
  style.textContent=".sth-cart-pop{position:fixed;inset:0;z-index:999999;display:none;align-items:center;justify-content:center;padding:18px;background:rgba(0,0,0,.38)}.sth-cart-pop.on{display:flex}.sth-cart-pop__card{width:min(520px,100%);background:#fff;color:#171513;border:1px solid #d9d0c8;box-shadow:0 28px 80px rgba(0,0,0,.24);padding:24px}.sth-cart-pop__top{display:flex;justify-content:space-between;gap:18px;align-items:start}.sth-cart-pop__eyebrow{font-size:10px;font-weight:800;letter-spacing:.14em;color:#9a6d4f}.sth-cart-pop h3{margin:6px 0 8px;font-family:var(--font-heading);font-size:2rem;font-weight:500}.sth-cart-pop p{margin:0;color:#6e655e;line-height:1.55}.sth-cart-pop__close{border:0;background:transparent;font-size:24px;cursor:pointer}.sth-cart-pop__qty{display:none;align-items:center;gap:10px;margin:20px 0}.sth-cart-pop__qty.on{display:flex}.sth-cart-pop__qty button{width:36px;height:36px;border:1px solid #cbc0b6;background:#fff;font-size:20px}.sth-cart-pop__qty strong{min-width:28px;text-align:center}.sth-cart-pop__actions{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-top:22px}.sth-cart-pop__actions a,.sth-cart-pop__actions button{display:flex;align-items:center;justify-content:center;min-height:46px;border:1px solid #171513;text-decoration:none;font:inherit;font-weight:800;cursor:pointer}.sth-cart-pop__continue{background:#fff;color:#171513}.sth-cart-pop__cart{background:#171513;color:#fff}.sth-cart-pop__checkout{grid-column:1/-1;background:#c79b74!important;color:#171513!important;border-color:#c79b74!important}.sth-cart-pop__note{margin-top:12px!important;font-size:11px!important}.sth-cart-pop__count{margin-top:8px;font-size:12px;font-weight:700}@media(max-width:560px){.sth-cart-pop{align-items:end;padding:0}.sth-cart-pop__card{border-radius:18px 18px 0 0;padding:22px 18px 26px}.sth-cart-pop__actions{grid-template-columns:1fr}.sth-cart-pop__checkout{grid-column:auto}}";
  document.head.appendChild(style);

  function ensure(){
    var el=document.querySelector("[data-sth-cart-pop]");
    if(el)return el;
    el=document.createElement("div");
    el.className="sth-cart-pop";
    el.setAttribute("data-sth-cart-pop","");
    el.innerHTML='<div class="sth-cart-pop__card" role="dialog" aria-modal="true" aria-labelledby="sth-cart-pop-title"><div class="sth-cart-pop__top"><div><div class="sth-cart-pop__eyebrow">SHOP TO HEAVEN</div><h3 id="sth-cart-pop-title" data-sth-pop-title>Your item is in the bag.</h3><p data-sth-pop-text>What would you like to do next?</p><div class="sth-cart-pop__count" data-sth-pop-count></div></div><button class="sth-cart-pop__close" data-sth-pop-close aria-label="Close">×</button></div><div class="sth-cart-pop__qty" data-sth-pop-qty><span>Quantity</span><button type="button" data-sth-minus>−</button><strong data-sth-qty>1</strong><button type="button" data-sth-plus>+</button></div><div class="sth-cart-pop__actions"><button type="button" class="sth-cart-pop__continue" data-sth-continue>Continue shopping</button><a class="sth-cart-pop__cart" href="/cart">View cart</a><a class="sth-cart-pop__checkout" href="/cart">Review order & gift options</a></div><p class="sth-cart-pop__note">Items in your bag are not reserved until checkout. Availability can change.</p></div>';
    document.body.appendChild(el);
    el.querySelector("[data-sth-pop-close]").addEventListener("click",close);
    el.querySelector("[data-sth-continue]").addEventListener("click",close);
    el.addEventListener("click",function(e){if(e.target===el)close();});
    el.querySelector("[data-sth-minus]").addEventListener("click",function(){changeQty(-1);});
    el.querySelector("[data-sth-plus]").addEventListener("click",function(){changeQty(1);});
    return el;
  }
  function close(){var el=ensure();el.classList.remove("on");document.documentElement.style.overflow="";}
  function open(opts){
    opts=opts||{};
    var now=Date.now();
    if(now-state.lastShown<700)return;
    state.lastShown=now;
    var el=ensure();
    el.querySelector("[data-sth-pop-title]").textContent=opts.title||"Your item is in the bag.";
    el.querySelector("[data-sth-pop-text]").textContent=opts.text||"Continue shopping, review your cart, or head to checkout.";
    el.querySelector("[data-sth-pop-count]").textContent=opts.count?opts.count+" item"+(opts.count===1?"":"s")+" in your bag":"";
    var q=el.querySelector("[data-sth-pop-qty]");
    q.classList.toggle("on",!!opts.allowQty&&!!state.lastKey);
    el.querySelector("[data-sth-qty]").textContent=String(state.lastQty||1);
    el.classList.add("on");
    el.querySelectorAll("a[href]").forEach(function(a){a.style.pointerEvents="auto";});
    document.documentElement.style.overflow="hidden";
  }
  async function changeQty(delta){
    if(!state.lastKey)return;
    var next=Math.max(0,(state.lastQty||1)+delta);
    try{
      var r=await fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json","X-STH-Cart-Assistant":"1"},body:JSON.stringify({id:state.lastKey,quantity:next})});
      var cart=await r.json();
      if(!r.ok)throw 0;
      state.lastQty=next;
      syncBagCount();
      var item=cart.items&&cart.items.find(function(x){return x.key===state.lastKey;});
      if(!item){state.lastKey=null;state.lastQty=1;}
      ensure().querySelector("[data-sth-qty]").textContent=String(state.lastQty);
      ensure().querySelector("[data-sth-pop-count]").textContent=cart.item_count+" item"+(cart.item_count===1?"":"s")+" in your bag";
      if(cart.item_count===0){sessionStorage.removeItem("sthCartActive");sessionStorage.removeItem("sthCartReminderDue");sessionStorage.removeItem("sthCartReminderIndex");clearReminderState();close();}
    }catch(e){}
  }
  function remember(result){
    sessionStorage.setItem("sthCartActive","1");
    if(!sessionStorage.getItem("sthCartReminderV3"))sessionStorage.setItem("sthCartReminderV3",JSON.stringify({startedAt:Date.now(),next:0}));
    var items=result&&result.items?result.items:[result];
    if(items.length===1&&items[0]){
      state.lastKey=items[0].key||null;
      state.lastQty=items[0].quantity||1;
      state.lastTitle=items[0].product_title||items[0].title||"";
      if(state.lastKey)sessionStorage.setItem("sthCartLastKey",state.lastKey);
    }else{
      state.lastKey=null;
      sessionStorage.removeItem("sthCartLastKey");
    }
  }
  document.addEventListener("click",function(e){var b=e.target.closest("add-to-cart-component button, product-form-component button[type=submit], button[name=add]");if(b)state.lastAddButton=b;},true);
  function flyToCart(){var b=state.lastAddButton;var dest=document.querySelector(".header-actions__cart-icon, cart-icon, a[href=\"/cart\"]");if(!b||!dest||window.matchMedia("(prefers-reduced-motion: reduce)").matches)return;var a=b.getBoundingClientRect(),z=dest.getBoundingClientRect();if(!a.width||!z.width)return;var ball=document.createElement("span");ball.textContent="✓";Object.assign(ball.style,{position:"fixed",left:(a.left+a.width/2)+"px",top:a.top+"px",width:"38px",height:"38px",borderRadius:"50%",background:"#171513",color:"#fff",display:"grid",placeItems:"center",fontWeight:"bold",zIndex:"2147483641",pointerEvents:"none"});document.body.appendChild(ball);ball.animate([{opacity:1,transform:"translate(-50%,0) scale(1)"},{opacity:0.2,transform:"translate("+(z.left-a.left)+"px,"+(z.top-a.top)+"px) scale(.35)"}],{duration:700,easing:"ease-in-out"}).finished.catch(function(){}).finally(function(){ball.remove();});}
  function showAdded(result,opts){
    syncBagCount();
    flyToCart();
    remember(result||{});
    scheduleReminder(false);
  }
  var originalFetch=window.fetch.bind(window);
  // Keep the header count accurate across all pages, additions, removals and bfcache.
  var countSyncTimer=null;
  async function syncBagCount(){
    try{
      var r=await originalFetch('/cart.js',{credentials:'same-origin',cache:'no-store'});
      if(!r.ok)return;
      var cart=await r.json(),count=Number(cart.item_count)||0;
      document.querySelectorAll('cart-icon').forEach(function(icon){
        var bubble=icon.querySelector('[ref="cartBubble"]')||icon.querySelector('.cart-bubble');
        var countNode=icon.querySelector('[ref="cartBubbleCount"]')||icon.querySelector('.cart-bubble__text-count');
        if(countNode){countNode.textContent=count<100?String(count):'99+';countNode.classList.toggle('hidden',count===0);}
        if(bubble)bubble.classList.toggle('visually-hidden',count===0);
        icon.classList.toggle('header-actions__cart-icon--has-cart',count>0);
      });
      document.querySelectorAll('[data-sth-bag-count]').forEach(function(el){el.textContent=String(count);el.setAttribute('aria-label',count+' items in shopping bag');});
      if(count===0){sessionStorage.removeItem('sthCartActive');sessionStorage.removeItem('sthCartReminderDue');sessionStorage.removeItem('sthCartReminderIndex');clearReminderState();}
    }catch(e){console.warn('[STH bag] Could not sync quantity',e);}
  }
  function queueBagSync(){clearTimeout(countSyncTimer);countSyncTimer=setTimeout(syncBagCount,180);}
  document.addEventListener('DOMContentLoaded',syncBagCount);
  window.addEventListener('pageshow',syncBagCount);
  document.addEventListener('cart:update',queueBagSync);
  document.addEventListener('cart:refresh',queueBagSync);
  document.addEventListener('click',function(e){
    var cartLink=e.target.closest('a[href="/cart"],a[href$="/cart"],[data-testid="cart-page-link"]');
    if(cartLink){e.preventDefault();window.location.assign('/cart');}
  },true);

  window.fetch=async function(){
    var args=Array.prototype.slice.call(arguments);
    var request=args[0],options=args[1]||{};
    var url=typeof request==="string"?request:(request&&request.url)||"";
    var res=await originalFetch.apply(window,args);
    try{
      var internal=options.headers&&((options.headers["X-STH-Cart-Assistant"])||(options.headers.get&&options.headers.get("X-STH-Cart-Assistant")));
      if(!internal&&res.ok&&/\/cart\/add(?:\.js)?(?:\?|$)/.test(url)){
        res.clone().json().then(function(data){showAdded(data);setTimeout(syncBagCount,220);}).catch(function(){});
      }
    }catch(e){}
    if(res.ok&&/\/cart\/(?:change|update|clear|add)(?:\.js)?(?:\?|$)/.test(url))setTimeout(syncBagCount,240);
    return res;
  };
  window.STHCartAssistant={showAdded:showAdded,open:open,close:close};


  var reminderOffsets=[30000,60000,150000,300000];
  function eligibleReminderPage(pathname){
    return !/(?:^|\/)(?:products|collections|search|cart|checkout|checkouts|account|orders)(?:\/|$)/i.test(pathname);
  }
  function clearReminderState(){
    clearTimeout(state.loadTimer);
    state.loadTimer=null;
    sessionStorage.removeItem("sthCartReminderV3");
    sessionStorage.removeItem("sthCartActive");
    sessionStorage.removeItem("sthCartReminderDue");
    sessionStorage.removeItem("sthCartReminderIndex");
  }
  function readReminderState(){
    try{
      var saved=JSON.parse(sessionStorage.getItem("sthCartReminderV3")||"null");
      if(saved&&Number.isFinite(saved.startedAt)&&Number.isInteger(saved.next)&&saved.next>=0&&saved.next<=4)return saved;
    }catch(error){}
    if(sessionStorage.getItem("sthCartActive")==="1"){
      var fresh={startedAt:Date.now(),next:0};
      sessionStorage.setItem("sthCartReminderV3",JSON.stringify(fresh));
      return fresh;
    }
    return null;
  }
  function scheduleReminder(skipMissed){
    clearTimeout(state.loadTimer);
    state.loadTimer=null;
    if(!eligibleReminderPage(window.location.pathname)||document.hidden)return;
    var saved=readReminderState();
    if(!saved||saved.next>=reminderOffsets.length)return;
    if(skipMissed){
      while(saved.next<reminderOffsets.length&&saved.startedAt+reminderOffsets[saved.next]<Date.now()-1000)saved.next++;
      sessionStorage.setItem("sthCartReminderV3",JSON.stringify(saved));
      if(saved.next>=reminderOffsets.length)return;
    }
    var due=saved.startedAt+reminderOffsets[saved.next];
    state.loadTimer=setTimeout(async function(){
      if(!eligibleReminderPage(window.location.pathname)||document.hidden)return;
      var current=readReminderState();
      if(!current||current.next!==saved.next)return;
      if(document.querySelector("[data-sth-cart-pop].on,dialog[open],cart-drawer[open]")){
        current.next++;
        sessionStorage.setItem("sthCartReminderV3",JSON.stringify(current));
        scheduleReminder(false);
        return;
      }
      try{
        var response=await originalFetch("/cart.js",{headers:{"Accept":"application/json"},credentials:"same-origin",cache:"no-store"});
        if(!response.ok)throw Error("Cart unavailable");
        var cart=await response.json();
        if(!cart.item_count){clearReminderState();close();return;}
        if(!eligibleReminderPage(window.location.pathname)||document.hidden)return;
        var messages=[
          {title:"Your bag is waiting",text:"Your selected items are in your bag. Continue exploring or review your order."},
          {title:"Need a little guidance?",text:"Keep exploring our styling and size guides. Your bag is ready when you are."},
          {title:"Ready when you are",text:"Review your selected sizes and colours whenever you are ready to checkout."},
          {title:"One last bag reminder",text:"Your selected items are still in your bag. This is the last reminder for this bag."}
        ];
        var message=messages[current.next];
        open({title:message.title,text:message.text,count:cart.item_count,allowQty:false});
        current.next++;
        sessionStorage.setItem("sthCartReminderV3",JSON.stringify(current));
        scheduleReminder(false);
      }catch(error){state.loadTimer=setTimeout(function(){scheduleReminder(true);},10000);}
    },Math.max(0,due-Date.now()));
  }
  document.addEventListener("keydown",function(event){if(event.key==="Escape")close();});
  document.addEventListener("visibilitychange",function(){scheduleReminder(true);});
  window.addEventListener("pageshow",function(){scheduleReminder(true);});
  window.addEventListener("popstate",function(){close();scheduleReminder(true);});
  function init(){
    sessionStorage.removeItem("sthOfferDue");
    sessionStorage.removeItem("sthOfferIndex");
    document.querySelectorAll("[data-sth-empty-offer]").forEach(function(panel){panel.remove();});
    ensure();
    scheduleReminder(true);
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init);else init();
})();